import type { MarkerAssetProps } from "./marker-asset.type";

import { useReferentialConditionRatingsDefaultColor } from "@/entities/referential/referential-condition-ratings";

import { MarkerCircle } from "../marker-circle";

const MarkerAsset = ({ color, scale }: MarkerAssetProps) => {
  const defaultColor = useReferentialConditionRatingsDefaultColor();

  return <MarkerCircle color={color ?? defaultColor} scale={scale} />;
};

export default MarkerAsset;
